import { useContext } from 'react';
import jsCookie from 'js-cookie';
import { keys } from 'lodash';
import { CookieContext } from '../../components/providers';
export var CookieMatcher = {
    prod: /\bskillshare_user_\b/,
    qa: /\bqa_skillshare_user_\b/,
};
export function useCookies() {
    var _a = useContext(CookieContext), cookies = _a.cookies, rawCookie = _a.rawCookie;
    var hasCookie = function (key) {
        return !!(cookies && keys(cookies).find(function (k) { return !!k.match(key); }));
    };
    var setCookie = function (_a) {
        var key = _a.key, value = _a.value, options = _a.options;
        if (!cookies) {
            return;
        }
        cookies[key] = value;
        jsCookie.set(key, value, options);
    };
    var getCookie = function (key) {
        if (!cookies) {
            return;
        }
        if (cookies[key]) {
            return cookies[key];
        }
        return jsCookie.get(key);
    };
    var removeCookie = function (key) {
        if (!cookies) {
            return;
        }
        delete cookies[key];
        jsCookie.remove(key);
    };
    return {
        cookies: cookies,
        rawCookie: rawCookie,
        hasCookie: hasCookie,
        setCookie: setCookie,
        getCookie: getCookie,
        removeCookie: removeCookie,
    };
}
//# sourceMappingURL=use-cookies.js.map